import { useMediaQuery, useTheme } from '@mui/material';
import { SelectChangeEvent } from '@mui/material';
import React from 'react';
import { DesktopStepper } from './components/DesktopStepper';
import { MyMobileStepper } from './components/MyMobileStepper';
import { useProfileState } from './hooks/useProfileState';
import { StepperProvider } from './context/StepperContext';

const ModifyAccountStepper: React.FC = () => {
  const {
    activeStep,
    handleNext,
    handleBack,
    isLastStep,
    saveError,
    setOriginalProfile,
    handleSave,
    handleReset: resetProfile,
    setSelectedProfileIndex,
    warningMessage,
    showWarning,
    updateStepValidation,
    originalProfile,
    isNewProfile,
    setIsNewProfile,
    goToLastStep,
    numOfSteps,
    setActiveStep,
  } = useProfileState();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const handleProfileChange = (event: SelectChangeEvent<number>) => {
    const newIndex = event.target.value as number;
    console.log('triggered handleProfileChange');
    if (setSelectedProfileIndex) {
      setSelectedProfileIndex(newIndex);
    }
  };

  const handleReset = () => {
    resetProfile();
  };

  const contextValue = {
    activeStep,
    handleNext,
    handleBack,
    handleReset,
    isLastStep,
    handleProfileChange,
    setOriginalProfile,
    handleSave,
    error: saveError,
    warningMessage,
    showWarning,
    updateStepValidation,
    originalProfile,
    isNewProfile,
    setIsNewProfile,
    goToLastStep,
    numOfSteps,
    setActiveStep,
  };

  return (
    <StepperProvider value={contextValue}>
      {matches ? <DesktopStepper /> : <MyMobileStepper />}
    </StepperProvider>
  );
};

export default ModifyAccountStepper;
